<template>
  <div class="page p20">
    <div class="page-header acsa">
      <div class="w280 tac">
        <!-- <el-button >返回</el-button> -->
        <el-button style="background-color: transparent; color: white; border: 1px solid #00f2ff" @click="goLogin">去管理端</el-button>
        <el-button style="background-color: transparent; color: white; border: 1px solid #00f2ff" v-if="adminData.page != '主页面'" @click="$router.go(-1)">返回上级</el-button>
      </div>
      <div class="tac pt20 fs36 fw600 flex1">中物联-{{ add_name }}可视化系统</div>
      <div class="w280 fs22 fw600">当前时间 {{ toDay }}</div>
    </div>
    <div class="acsb">
      <div>
        <div class="kuai-bg w410 h320">
          <div class="kuai-title">区域概况统计</div>
          <div class="p25">
            <div class="zuo-top w330 h120">
              <div class="acsb fw500">
                <div class="w90">
                  <div class="p10">
                    <div>{{ adminData.zuo1[0].name }}</div>
                    <div class="fw600" style="color: #2ccbff">{{ adminData.zuo1[0].value }}</div>
                  </div>
                  <div class="p10">
                    <div>{{ adminData.zuo1[1].name }}</div>
                    <div class="fw600" style="color: #2ccbff">{{ adminData.zuo1[1].value }}</div>
                  </div>
                </div>
                <div class="tac flex1">
                  <div class="jinsefont fs26 fw600">{{ adminData.everyone / 10000 }}</div>
                  <div>总人口(万)</div>
                </div>
                <div class="w90">
                  <div class="p10">
                    <div>{{ adminData.zuo1[2].name }}</div>
                    <div class="fw600" style="color: #2ccbff">{{ adminData.zuo1[2].value }}</div>
                  </div>
                  <div class="p10">
                    <div>{{ adminData.zuo1[3].name }}</div>
                    <div class="fw600" style="color: #2ccbff">{{ adminData.zuo1[3].value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 简单图表 -->
            <div style="margin-top: -40px">
              <div id="zuo1" class="w400 h220"></div>
            </div>
          </div>
        </div>
        <!-- 左2 -->
        <div class="kuai-bg w410 h320 mt20">
          <div class="kuai-title">人群统计</div>
          <div class="p25">
            <div v-for="(item, index) in adminData.zuo3" :key="index">
              <div class="ac mb20">
                <div class="w100 fw600">{{ item.name }}</div>
                <div class="flex1">
                  <el-progress :percentage="item.value" :stroke-width="12" define-back-color="#051f3d" color="#02d7fc" :show-text="false"></el-progress>
                </div>
                <div class="ml10 fw600">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 中间地图 -->
      <div class="flex1">
        <div ref="mapChart" style="width: 100%; min-width: 400px; height: 660px"></div>
      </div>

      <div>
        <!-- 右1 -->
        <div class="kuai-bg w410 h320">
          <div class="kuai-title">养殖信息统计</div>

          <div id="you1" class="w440 h320"></div>
        </div>
        <!-- 右2 -->
        <div class="kuai-bg w410 h320 mt20">
          <div class="kuai-title">乡镇养殖概况</div>

          <div class="fs12 pt10 pl20 pr20">
            <div class="acsa paiming-title">
              <div class="w40 tac">排名</div>
              <div class="w100 tac">乡镇</div>
              <div class="w70 tac">区县</div>
              <div class="w70 tac">市级</div>
              <div class="w40 tac">数量</div>
            </div>
            <div v-for="(item, index) in adminData.get_sorted_town_sums" :key="index">
              <div class="acsa mt6" :class="[index % 2 != 0 ? 'paiming' : 'paiming-no']">
                <div class="w40 tac">{{ item.index }}</div>
                <div class="w100 tac">{{ item.town_name }}</div>
                <div class="w70 tac">{{ item.county_name }}</div>
                <div class="w70 tac">{{ item.city_name }}</div>
                <div class="w40 tac">{{ item.total_num }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="acsb mt20" style="position: fixed; bottom: 40px; left: 20px; right: 20px; top: 780px">
      <div class="zuoxia-bg w1200 h250 mr20">
        <div class="kuai-title">种殖信息统计</div>
        <div class="ac">
          <!-- 圆饼图 -->
          <div id="byuan" class="w440 h220"></div>
          <!-- 排名 -->
          <div class="w400 fs12">
            <img src="https://img.iiar.cn/files/20250818/79HPBWYT.png" alt="" />
            <div class="acsa biaoge">
              <div>种类</div>
              <div>区县</div>
              <div>乡镇</div>
              <div>数量</div>
            </div>
            <div v-for="(item, index) in adminData.chandi_top" :key="index">
              <div class="acsa mt6 biaoge">
                <div class="tac w100">{{ item.name }}</div>
                <div class="tac w100">{{ item.county_name }}</div>
                <div class="tac w100">{{ item.town_name }}</div>
                <div class="tac w100">{{ item.value }}</div>
              </div>
            </div>
          </div>

          <!-- 四个图表 -->
          <div class="w360 pt20">
            <div class="acsa wrap">
              <div v-for="(item, index) in pageData.tubiao4" :key="index">
                <div :style="{backgroundImage: 'url(' + item.bg_img + ')'}" style="background-repeat: no-repeat; background-position: center" class="w130 h100 tac">
                  <div class="jinsefont">
                    {{ adminData.zhongzhi_top[item.name] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="youxia-bg h250 flex1">
        <div class="kuai-title">县域企业</div>

        <div class="ac">
          <!-- 公司信息 -->
          <div class="p20">
            <div v-for="(item, index) in adminData.companyInfo.tops" :key="index">
              <div :class="index % 2 === 0 ? 'gongsi-top' : 'gongsi-top-huang'">
                <div class="tac pt6">{{ item }}</div>
              </div>
            </div>
          </div>
          <!-- 四个图表 -->
          <div class="flex1">
            <img src="https://img.iiar.cn/files/20250818/QE4C9NIR.png" alt="" />
            <div class="acsa">
              <div class="xiasan p20 h80">
                <div class="jinsefont fs18">{{ adminData.companyInfo.total_quotas }}万</div>
                <div>年产值</div>
              </div>
              <div class="xiasan p20 h80">
                <div class="jinsefont fs18">{{ adminData.companyInfo.peoples }}人</div>
                <div>解决就业</div>
              </div>
              <div class="xiasan p20 h80">
                <div class="jinsefont fs18">{{ adminData.companyInfo.all_num }}家</div>
                <div>企业数量</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import gansuData from './map.json'
import {http_get, http_post} from '@/api/api'
export default {
  data() {
    return {
      add_name: '智能',
      toDay: '',
      localData: null,
      pageData: {
        zuo1: {
          xAxis: {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#cccccc' // X轴线条颜色（改为浅灰色）
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#cccccc' // 如果需要，Y轴线条也可以改颜色
              }
            },
            splitLine: {
              lineStyle: {
                color: '#3d455d' // 横向参考线颜色（浅灰色）
              }
            }
          },
          series: [
            {
              data: [],
              type: 'line',
              lineStyle: {
                color: '#5170fe',
                width: 2
              },
              itemStyle: {
                color: '#3d455d',
                width: 1
              },
              symbolSize: 10
            }
          ]
        },
        you1: {
          xAxis: {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#cccccc'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#cccccc'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#092343',
                type: 'dashed',
                width: 1
              }
            }
          },
          series: [
            {
              data: [],
              type: 'line',
              lineStyle: {
                color: '#5170fe',
                width: 2
              },
              itemStyle: {
                color: '#3d455d',
                width: 1
              },
              symbolSize: 10,
              areaStyle: {
                // 折线下方的填充区域
                color: '#01223a', // 使用和折线相同的颜色
                opacity: 0.9 // 透明度（0.1表示10%，数值越小越浅）
              }
            }
          ]
        },
        yuanb: {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            right: '10%',
            top: '20%', // 距离顶部 5%
            orient: 'vertical', // 垂直排列（可选）

            textStyle: {
              color: '#fff' // 图例文字颜色
            }
          },
          series: [
            {
              name: '种植作物',
              type: 'pie',
              radius: ['40%', '70%'],

              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 4
              },
              label: {
                show: true,
                position: 'center',
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 20
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 40,
                  fontWeight: 'bold',
                  color: '#fff'
                }
              },
              labelLine: {
                show: false
              },
              data: []
            }
          ]
        },
        tubiao4: [
          {
            name: 'town_name',
            bg_img: 'https://img.iiar.cn/files/20250818/E6OIDYOY.png'
          },
          {
            name: 'one',
            bg_img: 'https://img.iiar.cn/files/20250818/6S9DYWPM.png'
          },
          {
            name: 'two',
            bg_img: 'https://img.iiar.cn/files/20250818/4NUDIFMY.png'
          },
          {
            name: 'three',
            bg_img: 'https://img.iiar.cn/files/20250818/NQVSGXPG.png'
          }
        ]
      },
      adminData: {
        page: '主页面',
        companyInfo: {
          all_num: 0,
          peoples: 0,
          total_quotas: 0,
          tops: ['产值第一企业', '产值第二企业', '产值第三企业', '产值第四企业']
        },
        everyone: 0,
        zuo1: [
          {
            name: '',
            value: 0
          },
          {
            name: '',
            value: 0
          },
          {
            name: '',
            value: 0
          },
          {
            name: '',
            value: 0
          }
        ],
        zuo_zhe: {
          names: [],
          data: []
        },
        chandi_top: [],
        get_sorted_town_sums: [],
        zhongzhi_top: {
          town_name: '',
          one: '',
          two: '',
          three: ''
        }
      }
    }
  },

  created() {
    // this.mapInit()

    const today = new Date()
    const year = today.getFullYear() // 获取年份（四位数）
    const month = String(today.getMonth() + 1).padStart(2, '0') // 获取月份，注意月份从0开始，需要加1，并且补零
    const day = String(today.getDate()).padStart(2, '0') // 获取日期，补零

    this.toDay = `${year}年${month}月${day}日`
    let code = this.$route.query.code

    // console.log('1111')
    http_post('/api/admin/statistics/index', {code: code}, 1).then(res => {
      if (res.code == 200) {
        this.adminData = res.data
        this.add_name = res.data.add_name
        this.zuoInit(res.data) // 左上角的图表
        this.yuanInit(res.data) // 左下角圆饼
        this.youInit(res.data) //右上角折线

        this.checkCode(res.data.add_name)
      }
    })
  },
  mounted() {
    window.onpopstate = this.handleUrlChange
  },

  methods: {
    goLogin() {
      this.$router.push({path: '/login'})
    },
    checkCode(name = null) {
      if (this.$route.query.code) {
        console.log(this.$route.query.code)
        http_get('/static/maps/' + this.$route.query.code + '.json').then(res => {
          this.mapInit(res) //中间地图
        })
        this.getMapData(this.$route.query.code)
      } else if (name && name != '甘肃省') {
        http_post('/api/admin/dashboard/get_map_data', {name: name}, 1).then(res => {
          if (res.code == 200) {
            this.getMapData(res.data.code)
          }
        })
      } else {
        this.mapInit(gansuData) //中间地图
      }
    },
    getMapData(code) {
      http_get('/static/maps/' + code + '.json').then(res => {
        try {
          this.mapInit(res) //中间地图
        } catch (error) {
          // 如果有异常，处理错误
          console.error('加载地图数据失败:', error)
          // this.handleError('地图数据加载失败');
        }
      })
    },
    handleUrlChange() {
      // 当 URL 变化时，强制刷新页面
      window.location.reload()
    },
    youInit(data) {
      var chartDom = document.getElementById('you1')
      var myChart = echarts.init(chartDom)
      var option
      this.pageData.you1.xAxis.data = data.you_zhe.names
      this.pageData.you1.series[0].data = data.you_zhe.data
      option = this.pageData.you1

      option && myChart.setOption(option)
    },
    yuanInit(data) {
      var chartDom = document.getElementById('byuan')
      var myChart = echarts.init(chartDom)
      var option
      // console.log(data.yuanbing)
      this.pageData.yuanb.series[0].data = data.yuanbing
      option = this.pageData.yuanb
      console.log(option)

      option && myChart.setOption(option)
    },

    zuoInit(data) {
      var chartDom = document.getElementById('zuo1')
      var myChart = echarts.init(chartDom)
      var option

      this.pageData.zuo1.xAxis.data = data.zuo_zhe.names
      this.pageData.zuo1.series[0].data = data.zuo_zhe.data

      option = this.pageData.zuo1
      console.log(option)

      option && myChart.setOption(option)
    },
    mapInit(gansuData) {
      echarts.registerMap('甘肃', gansuData)

      const chart = echarts.init(this.$refs.mapChart)
      // 配置项

      const option = {
        // 提示框配置
        tooltip: {
          trigger: 'item',
          formatter: '{b}'
        },
        // 系列配置（只有一个series数组）
        series: [
          {
            name: '甘肃省',
            type: 'map',
            map: '甘肃',
            roam: true,
            zoom: 1.2,
            label: {
              show: true,
              color: '#000', // 白色标签
              fontSize: 12,
              fontWeight: 'bold',
              backgroundColor: '#17ebdf',
              padding: 5,
              borderRadius: 4
            },

            itemStyle: {
              areaColor: 'transparent',
              borderColor: '#00f2ff',
              borderWidth: 3,
              shadowColor: '#00f2ff',
              shadowBlur: 15
            },
            select: {
              itemStyle: {
                areaColor: '#fff'
              }
            },
            emphasis: {
              label: {
                color: '#fff',
                fontSize: 14
              },
              itemStyle: {
                areaColor: '#fff',
                borderColor: '#00f2ff',
                borderWidth: 2
              }
            },

            data: this.generateRandomData(gansuData)
          }
        ]
      }

      // 设置配置项并渲染
      chart.setOption(option)

      // 响应式调整
      window.addEventListener('resize', function () {
        chart.resize()
      })

      chart.on('click', this.handleMapClick)
    },
    handleMapClick(params) {
      // console.log('点击的地区：', params.name) // 输出点击的地区名称
      // 如果。params.name包含 镇、乡 则直接return
      // params.name.includes('镇') ||
      if (params.name.includes('村')) {
        return
      }

      http_post('/api/admin/dashboard/get_map_data', {name: params.name}, 1).then(res => {
        if (res.code == 200) {
          const currentUrl = new URL(window.location.href)
          const query = {
            code: res.data.code,
            time: Date.now() // 取8位
          }
          this.$router.push({currentUrl, query})

          window.location.reload() // 刷新页面
        }
      })
    },
    generateRandomData(gansuData) {
      return gansuData.features.map(feature => {
        return {
          name: feature.properties.name
          // value: Math.round(Math.random() * 100)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background-image: url('https://img.iiar.cn/files/20250818/HGHPUB27.png');
  background-size: cover; /* 背景图缩放到覆盖整个容器 */
  background-position: center center; /* 背景图居中 */
  background-repeat: no-repeat; /* 禁止背景图重复 */
  min-height: 100vh; /* 保证至少占满视口高度 */
  height: 100%; /* 高度为 100% */
  overflow: hidden; /* 隐藏超出的部分 */

  color: #fff;
}
.page-header {
  background-image: url('https://img.iiar.cn/files/20250818/2272TX6Z.png');
  background-repeat: no-repeat; /* 禁止背景图重复 */
  background-position: center;
  width: 100%;
  height: 100px;
}

.kuai-bg {
  background-image: url('https://img.iiar.cn/files/20250818/HEMMCK3G.png');
  // background-size: cover; /* 背景图占满整个容器 */
  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
}
.zuoxia-bg {
  background-image: url('https://img.iiar.cn/files/20250818/7S8RCY43.png');
  // background-size: cover; /* 背景图占满整个容器 */
  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
}

.youxia-bg {
  background-image: url('https://img.iiar.cn/files/20250818/O6HZOITQ.png');

  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
}

.kuai-title {
  font-size: 16px;
  font-weight: bold;
  padding-left: 30px;
  padding-top: 15px;
}

.zuo-top {
  background-image: url('https://img.iiar.cn/files/20250818/2KFBTFSP.png');
  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
}
.jinsefont {
  font-weight: 600;

  background: linear-gradient(to bottom, #f6f682, #febb0f);
  /* 将背景裁剪到文字 */
  -webkit-background-clip: text;
  background-clip: text;

  /* 透明文字（显示背景渐变） */
  color: transparent;

  /* 兼容性处理 */
  display: inline-block; /* 确保渐变生效 */
}
.biaoge {
  background-color: #091f3e;
  border: 2px solid #163f73;
  border-radius: 4px;
  padding: 2px 10px;
  color: #6990bf;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.paiming {
  background-color: #091f3e;
  border: 2px solid #163f73;
  border-radius: 4px;
  padding: 2px;
  color: #6990bf;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.paiming-no {
  padding: 2px;
  color: #6990bf;
}

.paiming-title {
  padding: 2px;
  color: #98c8ff;
  border-top: 1px solid #8dadc2;

  /* 背景渐变（从上到下：#0091c2 → #01132d） */
  background: linear-gradient(to bottom, #0091c2, #051f43);
}

.gongsi-top {
  background-image: url('https://img.iiar.cn/files/20250818/OABVTL19.png');
  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
  width: 200px;
  height: 36px;
  margin-bottom: 10px;
}

.gongsi-top-huang {
  background-image: url('https://img.iiar.cn/files/20250818/BO7HH37B.png');
  background-size: 100% 100%;
  background-repeat: no-repeat; /* 禁止背景图重复 */
  width: 200px;
  height: 36px;
  margin-bottom: 10px;
}

.xiasan {
  background-image: url('https://img.iiar.cn/files/20250818/9XSBRJL5.png');
  background-repeat: no-repeat;
  background-position: bottom;
}
</style>
